import React, { useEffect, useState } from "react";
import {useLocation} from "react-router-dom";
import "./index.scss";
import Avatar from '../../../../img/userCenter/avatar.png'
import Collected from "images/collected.png";
import CollectWork from "images/collectWork.png";
import Item from "antd/lib/list/Item";
import Request from "@/networkReq/request";
import Http from "@/networkReq/http"
import {message} from "antd"
import {getcodeValue} from 'utils/storage';
const jobData = {
  // name: "xxx职位",
  // area: "眉山市 东坡区",
  // companyName: "xxx公司",
  // recruitmentNum: 100,
  // salary: "13-17k",
  // workYear: "3-5",
  // education: "本科",
  // type: "私营企业",
  // enterpriseNum: "100-499",
  // treatment: "通讯补贴，员工旅游，五险一金，定期体检，",
  // deliveryTime: "2022-07-03",
  // deadlineTime: "2022-02-02",
  // humanAffairsName: "李晓天人事",
  // humanAffairsPhone: "18888888888",
  // jobNum: 5,
  // arriveTime: "2022",
  // ageRequire: "18-99",
  // genderRequire: "不限",
  // jobDescribe: [
  //   "职位要求啥啥都会职位要求啥啥都会职位要求啥啥都会职位要求啥啥都会职位要求啥啥都会职位要求啥啥都会；",
  //   "职位要求啥啥都会职位要求啥啥都会职位要求啥啥都会职位要求啥啥都会职位要求啥啥都会职位要求啥啥都会；",
  //   "职位要求啥啥都会职位要求啥啥都会职位要求啥啥都会职位要求啥啥都会职位要求啥啥都会职位要求啥啥都会；",
  //   "职位要求啥啥都会职位要求啥啥都会职位要求啥啥都会职位要求啥啥都会职位要求啥啥都会职位要求啥啥都会；",
  //   "职位要求啥啥都会职位要求啥啥都会职位要求啥啥都会职位要求啥啥都会职位要求啥啥都会职位要求啥啥都会；",
  // ]
}

export default function JobDetail(props) {
  const location = useLocation()
  const [state, setState] = useState(jobData);
  console.log('statestatestate',state);
  
  useEffect(() => {
    console.log('------useEffect------',location);
    let dataId = location.pathname.split('/').slice(-1)[0]
    console.log('ididididididididiid',dataId);
    
    setState({ ...state, arriveTime: '一周内'})
    Http.getApplication(Request.getJobDetail(),{id:dataId},(obj)=>{
      console.log(obj);
      if(obj.code == 200){
          // getListInfo()
          setState(obj.data)
          // message.success('删除成功')
      }else{
        message.error(`${obj.msg}`)
      }})
  },[])

  return (
    <div className={"job_detail"}>
      <section className={"job_item"}>
        <div className="job_item_header">
          <div className={"job_item_title job_item_detail"}>
            <div className={"job_item_left"}>
              <span className={"job_item_name"}>{state.job}</span>
              <span className={"job_item_area"}>「{state.workArea}」</span>
            </div>
            <div className={"job_item_collection"}>
              <div>
                <span className={"job_item_delivery_time"}>发布时间：</span>
                <span className={"job_item_delivery_time"}>{state.jobReleaseTime}</span>
              </div>
            </div>
          </div>
          <div className={"job_item_info job_item_detail"}>
            <div className={"job_item_left"}>
              <span className={"job_item_salary"}>{state.salary}</span>
              <span className={"job_item_work_year"}>{state.workExperience}</span>
              <span className={"job_item_split"}>|</span>
              <span className={"job_item_education"}>{getcodeValue('edu_lev_code',state.degree)}</span>
            </div>

          </div>
        </div>
        <div className={"job_item_footer"}>
          <div className={"job_item_left"}>
            <span className={"job_item_treatment"}>{state.welfare}</span>
          </div>
        </div>
      </section>

      {/* 岗位信息及要求 */}
      <section className="job_item_require_info">
        <div className="job_item_require_detail">
          <div className="job_item_human_affairs">
            <div>
              {/* <img src={Avatar} alt="" className="job_item_human_affairs_img" /> */}
            </div>
            <div className="human_affairs_info">
              <div className="human_affairs_name" style={{fontSize:"16px",fontWeight:"bold"}}>{state.jobInformationContacts}</div>
              <div className="phone_job_deadline_time">
                <div className="human_affairs_phone">
                  联系电话：{state.jobInformationTel}
                </div>
                <div className="job_deadline_time">
                  招聘截止日期：{state.deadline}
                </div>
              </div>
            </div>
          </div>

          {/* 职位描述 */}
          <div className="job_describe_info">
            <div className="job_require_describe" style={{fontSize:"16px",fontWeight:"bold"}}>职位描述：</div>
            <div className="job_info">
              <div>
                <span className="job_info_title" style={{fontWeight:"400",fontSize:'16px',color:"#767676"}}>招聘人数：</span>
                <span className="job_info_require" style={{fontWeight:"500"}}>{state.recruitsNumber}</span>
              </div>
              <div>
                <span className="job_info_title" style={{fontWeight:"400",fontSize:'16px',color:"#767676"}}>到岗时间：</span>
                <span className="job_info_require" style={{fontWeight:"500"}}>{state.onDutyTime}</span>
              </div>
              <div>
                <span className="job_info_title" style={{fontWeight:"400",fontSize:'16px',color:"#767676"}}>年龄要求：</span>
                <span className="job_info_require" style={{fontWeight:"500"}}>{state.ageRange}</span>
              </div>
              <div>
                <span className="job_info_title" style={{fontWeight:"400",fontSize:'16px',color:"#767676"}}>性别要求：</span>
                <span className="job_info_require" style={{fontWeight:"500"}}>{state.genderAsk}</span>
              </div>
              {/* <div>
                <span className="job_info_title" style={{fontWeight:"400",fontSize:'16px',color:"#767676"}}>婚况要求：</span>
                <span className="job_info_require" style={{fontWeight:"500"}}>{state.marryState}</span>
              </div> */}
            </div>
            <div className="job_describe">
              <div className="job_info_title" style={{fontWeight:"400",fontSize:'16px',color:"#767676"}}>职位描述：</div>
              <div className="job_describe_item" style={{fontWeight:"500",fontSize:"16px",color:"#2E2E2E"}}>
                {/* {state.jobDescribe.map((item, index) => {
                  const element = (
                    <div key={index}>
                      <span className="job_skill_require">{index + 1}、</span>
                      <span className="job_skill_require">{item}</span>
                    </div>
                  );
                  return element;
                })} */}
                {state.jobDescription}
              </div>
            </div>
            <div className="job_describe">
              <div className="job_info_title" style={{fontWeight:"bold"}}>任职要求：</div>
              <div className="job_describe_item" style={{fontWeight:"500",fontSize:"16px",color:"#2E2E2E"}}>
                {/* {state.jobDescribe.map((item, index) => {
                  const element = (
                    <div key={index}>
                      <span className="job_skill_require">{index + 1}、</span>
                      <span className="job_skill_require">{item}</span>
                    </div>
                  );
                  return element;
                })} */}
                {state.jobRequirements}
              </div>
            </div>
          </div>
        </div>
        <div className="job_item_company_info">
          <div className="company_name">
            <span >{state?.sybAuditMechanism?.auditMechanismName}</span>
          </div>
          {/* <div className="recruit_number">
            <span className="job_info_title">招聘人数：</span>
            <span className="job_info_require">{state.recruitsNumber}</span>
          </div> */}
          <div className="company_nature">
            <span className="job_info_title"><p className="job_info_require" style={{lineBreak:'anywhere',marginTop:"16px",fontSize:"14px"}}>{`公司邮箱：${state?.jobEmail}`}</p></span>
            {/* <span className="job_info_require">{state?.jobEmail}</span> */}
          </div>
          <div className="company_nature">
            {/* <span className="job_info_title">公司地址：</span> */}
            <span className="job_info_title"><p className="job_info_require" style={{lineBreak:'anywhere',fontSize:"14px"}}>{`工作地址：${state.workArea}`}</p></span>
          </div>
          <div className="company_profile">
          <div className="job_info_title" style={{fontSize:"14px",color:"#2E2E2E"}}>公司简介：</div>
          <span className="job_info_comdetail" ><p style={{fontSize:"14px"}}>{state?.sybAuditMechanism?.auditMechanismIntroduce}</p></span>
          </div>
        </div>
      </section>
      <section className="audit_container">
        <div className="audit_title">
          <span >审核结果</span>
        </div>
        {
          state.jobInformationState==0?
          <div className="audit_result pending">
              <span>申请审核中</span> 
        </div>:
        state.jobInformationState==1?
        <div className="audit_result success">
              <span>申请通过</span>
        </div>:
        state.jobInformationState==2?
        <div className="audit_result failed">
          <span>申请不通过</span>
        </div>:''
        }
        {
          state.jobInformationState==2?
          <div className="failure_cause">
          <span className="job_info_title">原因：</span>
              <span className="job_info_require">{state.jobInformationReason}</span>
        </div>:''
        }
        
      </section>
    </div>
  );
}
